<div class="modal-header bg-primary text-white d-flex align-items-center justify-content-between">
    <div>
        <span class="session-header-title">Create Saved View</span>
    </div>
    <button type="button" class="close-button" aria-label="Close" (click)="closeModal()">×</button>
</div>

<div class="modal-body">
    <!-- Name field -->
    <div class="mb-3">
        <label for="name" class="form-label">Name</label>
        <input type="text" id="name" class="form-control" [class.is-invalid]="nameTouched && isNameInvalid" [(ngModel)]="name" (blur)="nameTouched = true" (input)="nameTouched = true" placeholder="Enter name" />
        @if (nameTouched && isNameInvalid) {
            <div class="invalid-feedback">
                Name is required.
            </div>
        }
    </div>

    <!-- Checkbox -->
    <div class="form-check">
        <input class="form-check-input" type="checkbox" id="setDefault" [(ngModel)]="setAsDefault" />
        <label class="form-check-label" for="setDefault">
            Set as default
        </label>
    </div>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="closeModal()">Cancel</button>
    <button type="button" class="btn btn-primary" [disabled]="isNameInvalid" (click)="onCreate()">Create</button>
</div>